import type { FC } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { TextField as MuiTextField } from '@material-ui/core'
import clsx from 'clsx'

import type { ITheme } from '@homeviews/styles'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2.5),

      '& .MuiInputBase-root': {
        minHeight: 38,
        fontWeight: 500,
      },

      '& legend': {
        display: 'none',
      },
      '& input': {
        paddingTop: '10.5px',
        paddingBottom: '10.5px',
      },
      '& fieldset': {
        top: 0,
        border: `1px solid ${theme.colors.fieldBorderColor}`,
      },
      '& .MuiFormHelperText-root': {
        marginLeft: 0,
      },
      '& .MuiOutlinedInput-root:not(.Mui-focused):not(.Mui-error):hover': {
        '& fieldset': {
          border: `1px solid ${theme.colors.fieldBorderColor}`,
        },
      },
    },
    wrapper: {},
    labelTop: {},
  }),
)

// todo fix types
const TextField: FC<any> = ({
  children,
  customVariant = 'labelTop',
  helperText,
  error,
  ...rest
}) => {
  const classes = useStyles()

  return (
    <div className={`${classes.wrapper} l-textFieldWrapper`}>
      <MuiTextField
        className={clsx(
          classes.root,
          customVariant === 'labelTop' && classes.labelTop,
        )}
        InputLabelProps={{
          shrink: true,
        }}
        variant={'outlined'}
        error={error}
        helperText={error ? helperText : ''}
        {...rest}
      >
        {children}
      </MuiTextField>
    </div>
  )
}

export default TextField
